//-------- runtime = 0 预生产 runtime = 1 生产 --------------
const runtime = 1
const APIBaseURL = ['https://api-dev.charging.keji.io/api/cpms/operation/v1', 'https://api.charging.keji.io/api/cpms/operation/v1']
const APIBaseURL2 = ['https://api-dev.charging.keji.io/dev/api/imcp/admin/v1', 'https://api.charging.keji.io/prod/api/imcp/admin/v1']
const WebSocketURL = ['ws.lq.keji.io', 'pre.ws.lq.keji.io', 'test.ws.lq.keji.io']
export default {
  WebSocketURL: WebSocketURL[runtime],
  wxData:{
    appid:'wx1e9dc464c9c03abc',
    wechatid:'ailaidianshanghu',
    state:'aioukeji',
    oauth2_scope:'snsapi_userinfo',
    wxDebug:runtime==0?true:false,
  },
  API: {
    BaseURL: APIBaseURL[runtime],
    BaseURL2:APIBaseURL2[runtime],
    Controller: {
      user: {
        getUserInfo: '',
        login: ''
      }
    }
  },
}

